<template>
  <Dialog
    titleAlign="left"
    :title="$$t('create.more')"
    :visible="renderData.visible"
    @close="onClose"
    customClass="audio-refer-item-op-items-dialog"
    mobileRenderType="drawerDialog"
  >
    <div
      class="audio-refer-item-op-items-dialog-content"
      :class="`audio-refer-item-op-items-dialog-content--${props.listRenderType}`"
    >
      <div
        class="audio-refer-item-op-item audio-refer-item-op-item-report"
        @click="doReport"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{ $$t("editor.report") }}</span>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";

import Button from "@/components/basic/button/Button.vue";

import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
} from "@/config/config.js";

import { storeToRefs } from "pinia";
import useUserDataStore from "@/store/userDataStore";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const userDataStore = useUserDataStore();

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router;
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
});
const emits = defineEmits([
  "update:visible",
  "report",
]);
const renderData = reactive({
  visible: props.visible,
});

const doReport = () => {
  emits("report");
  renderData.visible = false;
};

const onClose = () => {
  renderData.visible = false;
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);

onMounted(() => {});
</script>
<style lang="scss">
.custom-dialog.audio-refer-item-op-items-dialog {
  padding: 0 0 0 16px;
  .dialog-box {
    max-height: 80% !important;
  }
  .dialog-header {
    padding: 0 60px 0 20px;
  }
  .audio-refer-item-op-items-dialog-content {
    padding: 0 0 32px 0;
  }
  .audio-refer-item-op-item {
    height: 44px;
    padding: 0 20px;
    line-height: 44px;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;

    i {
      width: 20px;
      height: 20px;
      display: none;
    }
    span {
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      color: #ffffff;
      // margin-left: 12px;
      margin: 0;
      flex: 0 1 auto;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
    &.disabledui {
      opacity: 0.5;
      i,
      span {
        cursor: not-allowed;
      }
      i.info-ico {
        cursor: pointer;
      }
    }
  }
}
</style>
